import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCardConfirm = _resolveComponent("ModalCardConfirm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ModalCardConfirm, {
            activeValidate: true,
            headerTitle: _ctx.title,
            maxWidth: _ctx.maxWidth,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
            onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }, 8, ["headerTitle", "maxWidth"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}